import React from 'react';
import './NotFound.css'
const NotFound = () => {
    return (
        <div>
            <div className="mb-5 pb-5 navb">
                <img style={{ width: "60%" }} src="https://i.ibb.co/5WV11pL/notFound.png" alt="" />
            </div>
        </div>
    );
};

export default NotFound;